<form nz-form *ngIf="mainformGroup" [formGroup]="mainformGroup">
    <div class="edit-panel-action" *ngIf="field.tableConfiguration.showLoadData" >
        <button nz-button nzType="primary" nzShape="circle" (click)="loadData()" nz-tooltip [nzTooltipTitle]="field.tableConfiguration.loadDataConfiguration?.tooltip|translateTA" >
        <nz-icon nzType="download" />
        </button>
    </div>
    <nz-table  *ngIf="!field.hidden"
            [nzPaginationType]="'small'"
            [nzShowPagination]="field.tableConfiguration.showPagination==null? true : field.tableConfiguration.showPagination"
            [nzSize]="field.tableConfiguration.size==null? 'small' : field.tableConfiguration.size"
            [nzPageSize]="pageSize"
            [nzPageIndex]="pageIndex"
            [nzFrontPagination]="false" 
            [nzData]="pagedRows" 
            [nzBordered]="true" 
            [nzTotal]="rows.length"
            [nzTableLayout]="field.tableConfiguration.layout!=null?field.tableConfiguration.layout:'fixed'"
            [nzScroll]="field.tableConfiguration.scroll!=null?field.tableConfiguration.scroll:{x:null,y:null}"
            (nzPageIndexChange)="pageIndex = $event; cd.detectChanges()">
        <thead>
        <tr>
            <th  *ngFor="let item of field.tableConfiguration.fields" [colSpan]="item.colSpan">{{item.label|translateTA}}</th>
            <th colSpan="1" *ngIf="showAction">{{'action'|translateTA}}</th>
        </tr>
        </thead>
        <tbody [formArrayName]="fieldNew">
            <tr [formGroup]="newRow" *ngIf="showAdd" class="row-insert-table">
                <td *ngFor="let item of field.tableConfiguration.fields" [colSpan]="item.colSpan">
                    <webhook-common [mainformGroup]="newRow" [field]="item" [variables]="variables"  [configuration]="this.configuration"  [rootForm]="newRow" > </webhook-common>
                </td>
                <td colSpan="1">
                    <button nz-button  nzType="primary" style="color: #ccecb8;" nzShape="circle" (click)="addRow()">
                        <nz-icon nzType="check" />
                    </button>
                </td>
            </tr>
            <tr *ngFor="let row of pagedRows; let i = index" [formGroupName]="(pageIndex - 1) * pageSize + i">
                @let rowindex = (pageIndex - 1) * pageSize + i;
                <td *ngFor="let item of field.tableConfiguration.fields" [colSpan]="item.colSpan">
                    <webhook-common [mainformGroup]="rows.at(rowindex)" [field]="item" [variables]="variables"  [configuration]="configuration" [rootForm]="rows.at(rowindex)"> </webhook-common>
                </td>
                <td colSpan="1" *ngIf="showRemove">
                    <button nz-button  nzType="primary" style="color: #ccecb8;" nzShape="circle" (click)="removeRow(rowindex)">
                        <nz-icon nzType="delete" style="color: #ccecb8;" />
                    </button>
                </td>
            </tr>
        </tbody>
    </nz-table>
</form>

